<div class="confirm-modal ig-modal input-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <div class="title">{{ data.inputModalTitle }}</div>
    <div class="m-t-3">
        <ig-field [label]="data.inputModalHelpText"
                  [required]="true"
                  [formControl]="form.get('text')"
                  [(ngModel)]="value">
        </ig-field>
    </div>

    <mat-dialog-actions align="end">
        <ig-button size="md" #confirmButton [isAsync]="data.isAsync" (trigger)="confirm($event)">{{ data.inputModalConfirmButtonText }}</ig-button>
        <ig-button size="md" class="btn-cancel" *ngIf="!confirmButton.isLoading" (trigger)="close()">{{ data.inputModalCancelButtonText }}</ig-button>
    </mat-dialog-actions>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/input.modal/input.modal.component.html